import { useRef, useState } from 'react';
import { useMultimodalLive } from '@/hooks/useMultimodalLive';

type Msg = { id: string; type: 'user'|'agent'; content: string; timestamp: Date };

export default function AgentPage() {
  const [messages, setMessages] = useState<Msg[]>([]);
  const seq = useRef(0);

  const live = useMultimodalLive({
    setMessages,
    messageSeqRef: seq,
  });

  const [text, setText] = useState('');

  const handleSend = () => {
    const content = text.trim();
    if (!content) return;
    setMessages((prev) => [...prev, { id: `${Date.now()}_${seq.current++}_user`, type: 'user', content, timestamp: new Date() }]);
    live.sendText(content);
    setText('');
  };

  return (
    <div style={{ padding: 16 }}>
      <h2>Multimodal Live (Test)</h2>
      <div style={{ marginBottom: 8 }}>
        <button onClick={() => live.handleConnectAgent()} disabled={live.agentStatus==='connecting' || live.agentStatus==='connected'}>
          {live.agentStatus==='connecting' ? 'Connecting…' : 'Connect'}
        </button>
        <button onClick={() => live.handleStopConversation()} style={{ marginLeft: 8 }} disabled={live.agentStatus!=='connected'}>
          Disconnect
        </button>
        <span style={{ marginLeft: 12 }}>Status: {live.agentStatus} • {live.sessionDuration}</span>
      </div>
      <div style={{ display: 'flex', gap: 8 }}>
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Type a prompt..." style={{ flex: 1 }} />
        <button onClick={handleSend} disabled={live.agentStatus!=='connected' || !text.trim()}>Send</button>
      </div>
      <div style={{ marginTop: 16, border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, height: 360, overflow: 'auto' }}>
        {messages.map((m) => (
          <div key={m.id} style={{ marginBottom: 8 }}>
            <strong>{m.type === 'user' ? 'You' : 'StudiBudi'}:</strong> {m.content}
          </div>
        ))}
        {live.isAgentTyping && <div><em>StudiBudi is talking…</em></div>}
      </div>
    </div>
  );
}
